// Hồ sơ người dùng + quản trị người dùng: đi qua API BACKEND (kiểm quyền ở backend).
// Trước đây file này (supabase.js) đọc/ghi bảng `users` TRỰC TIẾP trên Supabase bằng anon key.
import { auth } from './firebase';
import { API_BASE_URL } from '../config.js';

const request = async (path, options = {}) => {
  const user = auth.currentUser;
  if (!user) throw new Error('Chưa đăng nhập');
  const token = await user.getIdToken();
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...(options.headers || {})
    }
  });

  let body = null;
  try {
    body = await response.json();
  } catch (e) {
    // server trả text (vd lỗi 500)
  }

  if (!response.ok) {
    const detail = body && (body.detail || body.message);
    throw new Error(
      `${typeof detail === 'string' ? detail : (detail ? JSON.stringify(detail) : 'Lỗi máy chủ')} (HTTP ${response.status})`
    );
  }
  return body;
};

export const userAPI = {
  // Hồ sơ của chính mình. Backend tự TẠO hồ sơ (gói FREE dùng thử) nếu đây là lần đăng nhập đầu.
  async getUserProfile() {
    try {
      const body = await request('/api/account/profile');
      return body.data;
    } catch (error) {
      console.error('❌ Error fetching user profile:', error);
      return null;
    }
  },

  // Cập nhật cài đặt (family_members, daily_budget, budget_threshold_percent) rồi trả hồ sơ mới
  async updateUserSettings(email, settings) {
    await request('/api/user/settings', { method: 'POST', body: JSON.stringify(settings) });
    return this.getUserProfile();
  },

  // ===== Quản trị (backend kiểm role ADMIN đang ACTIVE) =====
  async getAllUsers() {
    const body = await request('/api/admin/user-list?limit=1000');
    return body.data.users;
  },

  async getUsersWithPagination(page = 1, limit = 20, filters = {}) {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (filters.status && filters.status !== 'ALL') params.set('status', filters.status);
    if (filters.role && filters.role !== 'ALL') params.set('role', filters.role);
    if (filters.search) params.set('search', filters.search);
    const body = await request(`/api/admin/user-list?${params.toString()}`);
    return { data: body.data.users, total: body.data.total };
  },

  banUser: (userId) => request(`/api/admin/users/${userId}/deactivate`, { method: 'POST', body: JSON.stringify({}) }),
  unbanUser: (userId) => request(`/api/admin/users/${userId}/activate`, { method: 'POST', body: JSON.stringify({}) }),
  promoteAdmin: (email) => request('/api/admin/admins', { method: 'POST', body: JSON.stringify({ email }) }),
  demoteAdmin: (email) => request(`/api/admin/admins/${encodeURIComponent(email)}`, { method: 'DELETE' })
};
